import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c0581c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type", "disabled"]

import type {
  PropType,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomButton1',
  props: {
  content: {
    type: String,
    required: true,
  },
  type: {
    type: String as PropType<'button' | 'submit' | 'reset'>,
    default: 'button',
    validator: (type: string) => type === 'button' || type === 'submit' || type === 'reset',
  },
  largeText: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  // category-1 is the blue button, category-2 is light blue button, category-3 is the cancel button, category-4 red button, category-5 yellow button
  category: {
    type: String as PropType<'category-1' | 'category-2' | 'category-3' | 'category-4'| 'category-5'>,
    default: 'category-1',
    validator: (type: string) => type === 'category-1' || type === 'category-2' || type === 'category-3'
    || type === 'category-4' || type === 'category-5',
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["mx-auto flex h-13 w-full items-center justify-center gap-1 rounded-lg text-center font-medium leading-[48px] transition-all duration-300 hover:transition-all hover:duration-300",  {
      'category-1-attr': __props.category === 'category-1' && !__props.disabled,
      'border border-blue-9 bg-blue-9 px-2 text-neutral-1 hover:border-neutral-1': __props.category === 'category-2'
        && !__props.disabled,
      'border border-[#F7F7F7] bg-[#F7F7F7] text-neutral-1 hover:border-neutral-1': __props.category === 'category-3'
        && !__props.disabled,
      'shadow-md': __props.category !== 'category-3',
      'text-[14px] sm:text-[16px] lg:text-[20px]': __props.largeText,
      'text-[12px] sm:text-[14px] lg:text-[16px]': !__props.largeText,
      'active-animation': !__props.disabled,
      'bg-neutral-1/10 text-neutral-1/60': __props.disabled,
      'px-8': __props.category === 'category-3',
      'category-4-attr': __props.category === 'category-4' && !__props.disabled,
      'category-5-attr': __props.category === 'category-5' && !__props.disabled,
    } ]),
    type: __props.type,
    disabled: __props.disabled
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createTextVNode(" " + _toDisplayString(__props.content), 1)
  ], 10, _hoisted_1))
}
}

})